import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {Contract} from "../../../../shared/interface/contract";
import {ContractBalance} from "../../../../shared/interface/contract-balance";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {TemplateService} from "../../../../shared/services/template.service";
import {
  CONTRACT_STATUS_CLOSED, CONTRACT_STATUS_ACTIVE, CONTRACT_TYPE_SELF_BILLING,
  CONTRACT_STATUS_DURING_TERMINATION, CONTRACT_STATUS_TERMINATED,
  CONTRACT_STATUS_TO_TERMINATE, CONTRACT_TYPE_AGREEMENT_FOR_PARTNER_POINTS,
  CONTRACT_TYPE_FRANCHISE, CONTRACT_TYPE_FRANCHISE_AGREEMENT, REGISTRATION_CONTRACT_TYPES,
  DictService, COMMISSION_SETTLEMENT_STATUS_TO_GENERATE
} from "../../../../shared/services/dict.service";
import {DownloaderService} from "../../../../shared/services/downloader.service";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ContractService} from "../../../../shared/services/contract.service";
import {Router} from "@angular/router";
import {AuthService} from "../../../../shared/services/auth.service";
import {takeUntil} from "rxjs/operators";
import {AddInitialBalanceComponent} from "../../invoices/add-initial-balance/add-initial-balance.component";
import {MatTableDataSource} from '@angular/material/table';
import {Document} from "../../../../shared/interface/document";
import {Invoice} from "../../../../shared/interface/invoice";
import {CommissionContractSettlement} from "../../../../shared/interface/commission-contract-settlement";
import {ContractBalanceService} from "../../../../shared/services/contract-balance.service";

@Component({
  selector: 'app-contract-balance-details-view',
  templateUrl: './contract-balance-details-view.component.html',
  styleUrls: ['./contract-balance-details-view.component.scss']
})
export class ContractBalanceDetailsViewComponent implements OnInit, OnDestroy {
  @Input() contractBalance: Observable<ContractBalance>;
  @Output() modifyClicked = new EventEmitter<any>();
  @Output() terminated = new EventEmitter<any>();

  contractBalanceObject?: ContractBalance;
  dataSource: MatTableDataSource<Invoice> = new MatTableDataSource<Invoice>([]);
  invoices: Invoice[];
  commissionContractSettlement: CommissionContractSettlement[];
  contractObject?: Contract;
  userPermissions: ReplaySubject<UserPermissions>;
  addInitialBalanceButton = false;
  displayedColumns: string[] = ['number', 'date', 'net', 'paymentDate', 'status'];
  displayedColumnsContractSettlement: string[] = ['billingMonth',  'totalCommission'];


  readonly CONTRACT_STATUS_ACTIVE = CONTRACT_STATUS_ACTIVE;
  readonly CONTRACT_STATUS_TO_TERMINATE = CONTRACT_STATUS_TO_TERMINATE;
  readonly CONTRACT_STATUS_DURING_TERMINATION = CONTRACT_STATUS_DURING_TERMINATION;
  readonly CONTRACT_STATUS_TERMINATED = CONTRACT_STATUS_TERMINATED;
  readonly CONTRACT_STATUS_CLOSED = CONTRACT_STATUS_CLOSED;
  readonly CONTRACT_TYPE_SELF_BILLING = CONTRACT_TYPE_SELF_BILLING;
  readonly REGISTRATION_CONTRACT_TYPES = REGISTRATION_CONTRACT_TYPES;
  readonly CONTRACT_TYPE_AGREEMENT_FOR_PARTNER_POINTS = CONTRACT_TYPE_AGREEMENT_FOR_PARTNER_POINTS;
  readonly CONTRACT_TYPE_FRANCHISE_AGREEMENT = CONTRACT_TYPE_FRANCHISE_AGREEMENT;
  readonly CONTRACT_TYPE_FRANCHISE = CONTRACT_TYPE_FRANCHISE;


  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private dialog: MatDialog,
    private contractBalanceService: ContractBalanceService,
    private router: Router,
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();

  }

  ngOnInit(): void {
    this.loadContractBalance();
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
  modify(): void {
    this.modifyClicked.emit();
  }

  addInitialBalance(): void{
    const dialogRef = this.dialog.open(AddInitialBalanceComponent, {
      width: '50vw',
      maxHeight: '90vh',
      data: {contract: this.contractBalanceObject.contract.uuid}
    });
    dialogRef.afterClosed().subscribe( result => {
      if (result) {
        this.getContractBalance(this.contractBalanceObject.uuid);
      }
    });
  }

  loadContractBalance(): void
  {
    this.contractBalance
      .pipe(takeUntil(this.destroyed$))
      .subscribe((contractBalance: ContractBalance) => {
        this.contractBalanceObject = contractBalance;
        this.contractObject = contractBalance.contract;
        this.invoices = contractBalance.invoices;
        this.invoices.sort((a, b) => a.billingMonth.localeCompare(b.billingMonth));
        this.commissionContractSettlement = contractBalance.commissionContractSettlements;
        this.commissionContractSettlement.sort((a, b) => a.commissionSettlement.billingMonth.localeCompare(b.commissionSettlement.billingMonth));
        if (contractBalance.contractStatus.key === CONTRACT_STATUS_ACTIVE){
          this.addInitialBalanceButton = true;
        }
      });
  }

  getContractBalance($uuid): void {
    this.contractBalanceService.get($uuid)
      .pipe()
      .subscribe((contractBalance: ContractBalance) => {
        this.contractBalanceObject = contractBalance;
        this.contractObject = contractBalance.contract;
        this.invoices = contractBalance.invoices;
        this.commissionContractSettlement = contractBalance.commissionContractSettlements;
        if (contractBalance.contractStatus.key === CONTRACT_STATUS_ACTIVE){
          this.addInitialBalanceButton = true;
        }
      });
  }

}
